/**
 * Sitemap alias for the cms-web fragment page that mounts ws-mycars-nav in
 * displayMode=headless-modal — hydrates that widget's real modal without
 * rendering its own icon, since MyCarsHeaderIcon is the icon on drawer sites.
 */
export const MYCARS_HEADER_FRAGMENT_ALIAS = 'DRAWER_MYCARS_HEADER_FRAGMENT';

/**
 * Sitemap alias for the cms-web fragment page that mounts ws-mycars-nav in
 * displayMode=inline-content — the chrome-less ModalNav/ModalCard content
 * embedded in the mobile drilldown panel (T44).
 */
export const MYCARS_CONTENT_FRAGMENT_ALIAS = 'DRAWER_MYCARS_CONTENT_FRAGMENT';

/**
 * Cross-widget event ws-mycars-nav listens for (document-scoped, matching the
 * ws-site-text-search-open-modal precedent) to open its already-hydrated modal.
 */
export const MYCARS_OPEN_MODAL_EVENT = 'ws-mycars-nav-open-modal';

/**
 * Event name ddc-mywallet-integration's own header-icon link already emits
 * on window.caiEventBus (a global mitt() instance, not a DOM CustomEvent) to
 * open its modal. Reused verbatim -- this is an existing production contract,
 * not one this repo owns or is introducing.
 */
export const MYWALLET_OPEN_EVENT = 'wallet:open';

/**
 * Key ddc-mywallet-integration is listed under in
 * /api/ipp/config/services' response. Its presence means My Wallet is
 * installed for the site; MYWALLET_OPEN_EVENT's bus is shared with other
 * integrations (uds:*) and therefore can't answer that question alone.
 */
export const MYWALLET_INTEGRATION_NAME = 'mywallet';

/**
 * Shared "open My Cars" sequence for every entry point that requests My
 * Cars' modal (MyCarsHeaderIcon's own button, and DrawerCTAButtons' desktop
 * button): close the drawer if it's open, then dispatch the cross-widget
 * open event. Kept as one function so the two call sites can't drift.
 *
 * @param {() => void} closeDrawer
 * @param {boolean} isOpen
 */
export const openMyCarsModal = (closeDrawer, isOpen) => {
	if (isOpen) closeDrawer();
	document.dispatchEvent(new CustomEvent(MYCARS_OPEN_MODAL_EVENT));
};
